












































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { MasterModule } from '@/app/store/modules/master'
import { Vuelidate } from 'vuelidate'
import { Validate } from 'vuelidate-property-decorators'
import {
  required,
  minLength,
  maxLength,
  not,
  sameAs,
} from 'vuelidate/lib/validators'
import { AdminCMSRoleModule } from '@/app/store/modules/adminCMSRole'

@Component({
  components: {},
})
export default class extends Vue {
  public name = ''
  public dashboard: number = 3
  public user: number = 3
  public notification: number = 3
  public material: number = 3
  public content: number = 3
  public report: number = 3
  public master: number = 3
  public admincms: number = 3
  public gallery: number = 3
  public test = {
    dashboard: '',
  }

  public menuOptions = [
    { text: 'Show', value: 1 },
    { text: 'Hide', value: 3 },
  ]
  public options = [
    {
      name: 'Dashboard',
      permission_id: 3,
    },
    {
      name: 'User',
      permission_id: 3,
    },
    {
      name: 'Notification',
      permission_id: 3,
    },
    {
      name: 'Material',
      permission_id: 3,
    },
    {
      name: 'Content',
      permission_id: 3,
    },
    {
      name: 'Report',
      permission_id: 3,
    },
    {
      name: 'Master',
      permission_id: 3,
    },
    {
      name: 'CMS Setting',
      permission_id: 3,
    },
    {
      name: 'Gallery Image',
      permission_id: 3,
    },
  ]

  public $v: Vuelidate
  @Validate({
    required,
    minLength: minLength(4),
  })
  public roleName: string = ''

  @Validate({
    required,
    minLength: minLength(4),
  })
  public email: string = ''

  @Validate({
    required,
    minLength: minLength(4),
  })
  public resetAdd() {
    this.$v.roleName.$reset()
    this.roleName = ''
    this.dashboard = 3
    this.notification = 3
    this.content = 3
    this.master = 3
    this.gallery = 3
    this.user = 3
    this.material = 3
    this.report = 3
    this.admincms = 3
    this.needSalesCode = false
  }

  public onClearSelected() {
    this.$emit('onClearSelected')
  }

  public stateDashboard = 3
  public stateNotification = 3
  public stateContent = 3
  public stateMaster = 3
  public stateGallery = 3
  public stateUser = 3
  public stateMaterial = 3
  public stateReport = 3
  public stateAdminCMS = 3
  public needSalesCode = false

  public postData(item, index, button) {
    this.$v.roleName.$touch()
    if (this.$v.roleName.$invalid) {
      this.stateDashboard = 1
      this.stateNotification = 1
      this.stateContent = 1
      this.stateMaster = 1
      this.stateGallery = 1
      this.stateUser = 1
      this.stateMaterial = 1
      this.stateReport = 1
      this.stateAdminCMS = 1
    } else {
      const dataToPost = {
        roleName: this.roleName,
        menu: this.options,
        needSalesCode: this.needSalesCode,
      }
      AdminCMSRoleModule.postAdminCMSRole(dataToPost)
      this.$root.$emit('bv::hide::modal', index, button)
    }
  }
}
